import React, { useState, useMemo } from 'react';
import Icon from '../../utils/icons';
import './TVMap.css';

const WINDY_API_KEY = 'ybBIOa6NnJzfNmLsT6bdNLGpW1dQacyp';

const WINDY_LAYERS = [
  { id: 'radar', name: 'Radar', icon: 'radio', overlay: 'radar', product: 'radar' },
  { id: 'temp', name: 'Temp', icon: 'thermometer', overlay: 'temp', product: 'ecmwf' },
  { id: 'wind', name: 'Wind', icon: 'wind', overlay: 'wind', product: 'ecmwf' },
  { id: 'rain', name: 'Rain', icon: 'rain', overlay: 'rain', product: 'ecmwf' },
  { id: 'clouds', name: 'Clouds', icon: 'cloud', overlay: 'clouds', product: 'ecmwf' },
  { id: 'aqi', name: 'Air Quality', icon: 'leaf', overlay: 'pm2p5', product: 'cams' },
];

function TVMap({ coordinates, location, weatherData, compact = false }) {
  const [mapLayer, setMapLayer] = useState('radar');

  const windyUrl = useMemo(() => {
    if (!coordinates?.lat || !coordinates?.lon) return null;

    const activeLayer = WINDY_LAYERS.find(l => l.id === mapLayer) || WINDY_LAYERS[0];
    const zoomLevel = compact ? 6 : 8;

    const params = new URLSearchParams({
      type: 'map',
      location: 'coordinates',
      key: WINDY_API_KEY,
      metricRain: 'in',
      metricTemp: '°F',
      metricWind: 'mph',
      zoom: zoomLevel.toString(),
      overlay: activeLayer.overlay,
      product: activeLayer.product,
      level: 'surface',
      lat: coordinates.lat.toFixed(4),
      lon: coordinates.lon.toFixed(4),
      message: 'true',
    });

    return `https://embed.windy.com/embed.html?${params.toString()}`;
  }, [coordinates, mapLayer, compact]);

  if (!coordinates?.lat || !coordinates?.lon) {
    return (
      <div className={`tv-map ${compact ? 'compact' : ''}`}>
        <div className="tv-map-placeholder">
          <Icon name="globe" size={compact ? 32 : 48} />
          <span>No location data</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`tv-map ${compact ? 'compact' : ''}`}>
      {/* Layer selector — only show in non-compact mode */}
      {!compact && (
        <div className="tv-map-layers">
          {WINDY_LAYERS.map((layer) => (
            <button
              key={layer.id}
              className={`tv-layer-btn ${mapLayer === layer.id ? 'active' : ''}`}
              onClick={() => setMapLayer(layer.id)}
              title={layer.name}
            >
              <Icon name={layer.icon} size={14} />
              <span>{layer.name}</span>
            </button>
          ))}
        </div>
      )}

      {/* Windy embed */}
      <div className="tv-map-container">
        <iframe
          title="Windy Weather Map"
          src={windyUrl}
          className="tv-windy-iframe"
          frameBorder="0"
          allowFullScreen
        />
      </div>

      {/* Location label */}
      <div className="tv-map-footer">
        <span className="tv-map-location">
          <Icon name="mapPin" size={12} /> {location}
        </span>
      </div>
    </div>
  );
}

export default TVMap;
